// 2026-07-18 - FormuLearning - 공통 AI Summary 위젯 (이슈 #40)
// 파일 위치: frontend/src/components/feedback/AiSummary.tsx
//
// Step1 원본 디자인을 공통화: 영문 요약을 본문에 표시하고, 마우스오버 시 한글 번역이
// 반투명 오버레이로 덮인다(영문이 비쳐 보임). 전 스텝·전 위치(접힘 헤더/펼침 본문) 공용.
// 요약 표시는 CardShell이 이 위젯 하나로 전담하여 "닫힘·열림 위치만 다르고 내용 동일"을 보장한다.

interface Props {
  en?: string | null
  ko?: string | null
}

export default function AiSummary({ en, ko }: Props) {
  if (!en && !ko) return null
  return (
    <div
      className="group relative rounded-md border p-3"
      style={{ borderColor: 'var(--border-teal)', background: 'var(--bg-chip-teal)' }}
    >
      <div className="mb-1 flex items-center gap-2">
        <p className="text-[10px] font-semibold uppercase text-accent-teal">AI Summary</p>
        {ko && <span className="ml-auto text-[9px] text-text-secondary">🇰🇷 hover for 한글</span>}
      </div>
      <p className="text-[11px] leading-relaxed text-text-body">{en || ko}</p>
      <p className="mt-1 text-[9px] italic text-text-secondary">⚠ AI-generated content — verify before use</p>

      {/* 마우스오버 시 한글 번역 반투명 레이어 (영문이 비쳐 보이게) */}
      {ko && (
        <div
          className="pointer-events-none absolute inset-0 flex flex-col rounded-md p-3 opacity-0 backdrop-blur-[2px] transition-opacity duration-200 group-hover:opacity-100"
          style={{ background: 'var(--overlay-bg)' }}
        >
          <p className="mb-1 text-[10px] font-semibold uppercase text-accent-teal">AI 요약 (한글)</p>
          <p className="overflow-auto text-[11px] leading-relaxed text-text-body">{ko}</p>
        </div>
      )}
    </div>
  )
}
